module.exports = __webpack_public_path__ + "static/media/lod-quad.3aa68d44.svg";